import React, { useState } from "react";
import Button from "~/common/Buttons";
import SocialMediaShareButton from "~/common/SocialMediaShare/SocialMediaShareButton";
import ZestVideoPlayer from "~/common/videoPlayer/ZestVideoPlayer";

interface Props {
  id: number;
  title: string;
  poster: string;
  description: string;
  hiddenDescription?: string;
  transcript: string;
  sources: {
    high: string;
    medium: string;
    low: string;
    product: string;
    ipad: string;
  };
  facebookShareUrl: string;
  twitterShareUrl: string;
  pinterestShareUrl: string;
  youtubeId: string;
  closedCaptionFile?: string;
}

export default function VideoContainer({
  id,
  title,
  poster,
  description,
  hiddenDescription,
  transcript,
  sources,
  facebookShareUrl,
  twitterShareUrl,
  pinterestShareUrl,
  youtubeId,
  closedCaptionFile,
}: Readonly<Props>) {
  const [showTranscript, setShowTranscript] = useState(false);
  const [showEmbedLink, setShowEmbedLink] = useState(false);
  const [showDescription, setShowDescription] = useState(true);

  return (
    <div id="gallery">
      <div className="box videoDetail">
        <div className="detailVideo">
          <div className="aspect-video">
            <ZestVideoPlayer
              posterImage={poster}
              title={title}
              sources={sources}
              currentIndex={0}
              selected={0}
              activePlayer={false}
              youtubeId={youtubeId}
              closedCaptionsrc={closedCaptionFile}
              playsInline
            />
          </div>
          <div className="btn-group">
            <Button
              type="button"
              color="custom"
              size="custom"
              className={`btn btn-mini btn-light ${
                showDescription ? "active" : ""
              }`}
              onClick={() => {
                setShowDescription(true);
                setShowEmbedLink(false);
                setShowTranscript(false);
              }}
            >
              About
            </Button>
            <Button
              type="button"
              color="custom"
              size="custom"
              className={`btn btn-mini btn-light ${
                showTranscript ? "active" : ""
              }`}
              onClick={() => {
                setShowDescription(false);
                setShowEmbedLink(false);
                setShowTranscript(true);
              }}
            >
              Transcript
            </Button>
            <Button
              type="button"
              color="custom"
              size="custom"
              className={`btn btn-mini btn-light ${
                showEmbedLink ? "active" : ""
              }`}
              onClick={() => {
                setShowDescription(false);
                setShowEmbedLink(true);
                setShowTranscript(false);
              }}
            >
              Embed
            </Button>
          </div>
          <div className="clearfix" />
          {showTranscript && (
            <div
              className="transcript"
              // eslint-disable-next-line react/no-danger
              dangerouslySetInnerHTML={{
                __html:
                  transcript && transcript.length > 0
                    ? transcript
                    : "(Transcript Unavailable)",
              }}
            />
          )}
          {showEmbedLink && (
            <div className="embed">
              <textarea
                spellCheck={false}
                className="EmbedInfo"
                value={`<div><iframe scrolling="no" width="392" height="226" src="https://www.webstaurantstore.com/v/?num=${id}&width=392&height=226&embed=1" frameBorder="0"></iframe>Courtesy of <a href="https://www.webstaurantstore.com">WebstaurantStore Restaurant Supplies</a></div>`}
              />
              <br />
              <i>Copy and paste the embed code above.</i>
            </div>
          )}
          {showDescription && (
            <div className="about">
              <p
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML={{
                  __html: description,
                }}
              />
              {hiddenDescription && hiddenDescription.length > 0 && (
                <p
                  // eslint-disable-next-line react/no-danger
                  dangerouslySetInnerHTML={{
                    __html: hiddenDescription,
                  }}
                />
              )}
            </div>
          )}
        </div>
        <div className="detailInfo" />
      </div>
      <div className="social-share">
        <div className="m-3">
          <div className="float-right -mt-2">
            <Button
              size="small"
              color="blue"
              href={`/ask.html?videotitle=${encodeURIComponent(
                title
              )}#askAQuestion`}
            >
              <i className="icon-question" /> Ask a question
            </Button>
          </div>
          <div className="flex flex-row">
            <SocialMediaShareButton
              site="Pinterest"
              shareUrl={pinterestShareUrl}
            />
            <SocialMediaShareButton
              site="Facebook"
              shareUrl={facebookShareUrl}
            />
            <SocialMediaShareButton site="Twitter" shareUrl={twitterShareUrl} />
          </div>
        </div>
      </div>
    </div>
  );
}
